import { HTTPClient } from '../utils/request'

export default {
  get: ({ query }) => HTTPClient.get(`/drivers${query}`),
  post: ({ payload = {}, query = ``, params = `` }) =>
    HTTPClient.post(`/drivers/${params}${query}`, payload),
  getById: ({ params }) => HTTPClient.get(`/drivers/${params._id}`),
  update: ({ payload }) =>
    HTTPClient.put(`/drivers/${payload.body._id}`, payload.body),
  switchStatus: ({ params, payload }) =>
    HTTPClient.post(`/drivers/${params._id}/${params.value}`, payload),
  store: ({ payload }) => HTTPClient.post(`/drivers/`, payload.body),
  attachVehicle: ({ params, payload }) =>
    HTTPClient.post(`/drivers/${params.driverId}/attach`, payload),
  detachVehicle: ({ params, payload }) =>
    HTTPClient.post(`/drivers/${params.driverId}/detach`, payload),
  find: ({ query }) => HTTPClient.get(`/drivers${query}`),
  favor: ({ params }) => HTTPClient.post(`/drivers/${params._id}/favorite`),
  track: ({ params }) => HTTPClient.post(`/drivers/${params._id}/track`),
  occurrence: ({ payload }) => HTTPClient.post(`/occurrence`, payload),
  audit: ({ query = `` }) => HTTPClient.get(`/driver/audit${query}`),
  recognition: ({ params }) =>
    HTTPClient.get(`/driver/recognition/${params._id}`),
  lotRecognition: () => HTTPClient.post(`/driver/checkCNH`),
  lgpd: ({ params }) => HTTPClient.post(`/drivers/${params._id}/lgpd`),
  protheus: ({ params }) =>
    HTTPClient.post(`/drivers/${params._id}/sync-in-protheus`),
  unlockDriver: ({ params, payload }) =>
    HTTPClient.post(`/drivers/enable/${params.cpf}`, payload),
  panic: ({ payload }) => HTTPClient.post(`/drivers/panic`, payload),
  setShipper: ({ payload, params }) => HTTPClient.post(`/drivers/setShipper/${params._id}`, payload),
  validatetrackings: ({ params }) =>
  HTTPClient.post(`/drivers/validatetracking/${params._id}`),
}
